import React from 'react';
import cn from 'classnames';
import type { OfficialAssetServerCategory } from '$/api/server.types';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import useThemeStore from '$/store/useThemeStore';

import { ASSET_LIBRARY_FOLDER_IMAGES } from '../../folderAsset/folderImages';
import styles from './index.module.scss';

export interface SubjectRailProps {
  subjects: OfficialAssetServerCategory[];
  selectedSubjectCode: string;
  onSubjectChange: (subject: OfficialAssetServerCategory) => void;
  ipSelected?: boolean;
  onSelectIp?: () => void;
}

/**
 * 官方资产类型栏，选中主题由父组件托管，切换时不清空标签筛选。
 */
function SubjectRail({
  subjects,
  selectedSubjectCode,
  onSubjectChange,
  ipSelected = false,
  onSelectIp,
}: SubjectRailProps): React.ReactElement {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const theme = useThemeStore((state) => state.theme);

  return (
    <aside className={cn(styles.subjectRail, { [styles.subjectRailIp]: ipSelected })}>
      <span className={styles.subjectRailTitle}>
        {languageStore.smartcatTranslationText((v) => v.asset_type)}
      </span>
      <div className={styles.subjectRailList}>
        {onSelectIp && (
        <button type="button" className={cn(styles.subjectRailItem, { [styles.subjectRailItemSelected]: ipSelected })} aria-pressed={ipSelected} onClick={onSelectIp}>
          <span className={styles.subjectRailIconWrap}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className={styles.subjectRailFolderIcon} src={ASSET_LIBRARY_FOLDER_IMAGES[theme].closed} alt="" crossOrigin="anonymous" />
            <IconFont
              name="portraitPhotoFill"
              fontSize={14}
              color="currentColor"
              className={styles.subjectRailTypeIcon}
            />
          </span>
          <span className={styles.subjectRailItemLabel}>{languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_ip_asset_title)}</span>
        </button>
        )}
        {subjects.map((subject) => {
          const selected = !ipSelected && subject.code === selectedSubjectCode;
          return (
            <button
              key={subject.code}
              type="button"
              className={cn(styles.subjectRailItem, { [styles.subjectRailItemSelected]: selected })}
              onClick={() => onSubjectChange(subject)}
            >
              <span className={styles.subjectRailIconWrap}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  crossOrigin="anonymous"
                  className={styles.subjectRailFolderIcon}
                  src={ASSET_LIBRARY_FOLDER_IMAGES[theme].closed}
                  alt=""
                />
                {subject.iconname && (
                  <IconFont
                    name={subject.iconname}
                    fontSize={14}
                    color="currentColor"
                    className={styles.subjectRailTypeIcon}
                  />
                )}
              </span>
              <span className={styles.subjectRailItemLabel}>{subject.name}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
}

export default SubjectRail;
